<template>
    <basic-container>
        <div class="relendging-flow-container">
            <div class="inner-con">
                <div class="project-title">{{processDetail.process?processDetail.process.processDefinitionName:''}}</div>
                <div class="project-status">
                    <div class="status-title">审批状态</div>
                    <div class="status-content" :class="['stateTopdiv', 'color_' + auditStatus]">
                        {{auditStatus == 0?'未提交':auditStatus == 1?'审批中':auditStatus == 2?'审批通过':'审批未通过'}}
                    </div>
                </div>

                <el-tabs v-model="activeName">
                    <el-tab-pane class="activelabel" label="项目详情" name="first">
                        <InfoContainer
                            style="margin-top:20px;"
                            :infoTitle="InfoContainerConfig['infoTitle']"
                            :contentConfig="InfoContainerConfig['infoContent']"
                        >
                            <template #basicInfo>
                                <!-- 明细表单 -->
                                <avue-crud
                                    :option="option"
                                    :data="tableData"
                                    ref="crud"
                                    :page.sync="page"
                                    @on-load="getList"
                                >
                                    <template slot-scope="scope" slot="menu">
                                        <!-- v-if="permission.visit_view" -->
                                        <div style="text-align: left">
                                            <el-button
                                                type="success"
                                                plain
                                                size="mini"
                                                icon="el-icon-arrow-right"
                                                @click.stop="handleDetail(scope.row)"
                                                >详情
                                            </el-button>
                                        </div>
                                    </template>
                                </avue-crud>
                                <div class="tabel-remark" v-if="processDetail.process && processDetail.process.variables.remark != ''">
                                    <span class="remark-title">备注:</span>
                                    {{processDetail.process?processDetail.process.variables.remark:''}}
                                </div>
                            </template>

                        </InfoContainer>

                        <!-- 流程公共附件 -->
                        <Accessory
                            v-loading="!dataReady"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(153, 153, 153, 0.8)"
                            v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
                            :batchFile="true"
                            :idname="uploadPermissionNameTwo"
                            :fileMenuUrlname="uploadPermissionNameOne"
                            :projectid="flowableId"
                            :upload="true"
                            :permissionList="permissionList"
                            :isPermission="true"
                        />

                        
                        <!-- 流程设计审批信息表单 -->
                        <AuditInfo
                            ref="auditInfo"
                            v-loading="!dataReady"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(153, 153, 153, 0.8)"
                            v-if="isStartedProcess && auditFormData && auditFormData != {}"
                            :formDetailData="auditFormData"
                            :isEditable="processDetail.process?processDetail.process.isEditable:false"
                            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
                        />
                        <!-- 会签意见区 -->
                        <CommentStep
                            v-loading="!dataReady"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(153, 153, 153, 0.8)"
                            v-if="commentList.length > 0"
                            :commentList="commentList"
                            :taskSaveData="taskSaveData"
                            :taskNo="processDetail.process?Number(processDetail.process.taskNo): 0"
                            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
                        />
                        <!-- 流程记录  -->
                        <CommentTable
                            v-loading="!dataReady"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(153, 153, 153, 0.8)"
                            v-if="flowData.length>0"
                            :flowData="flowData"
                        />

                        <!-- 会签意见区 -->
                        <InfoContainer
                            v-if="!isStartedProcess"
                            class="comment-container"
                            style="margin-top:20px;"
                            :infoTitle="commentBlockConfig['infoTitle']"
                            :contentConfig="commentBlockConfig['infoContent']"
                        >
                            <template #comment>
                                <CommentBlock
                                    ref="commentBlock"
                                    @fileChange="fileChange"
                                    :id='id'
                                />
                            </template>
                        </InfoContainer>

                    </el-tab-pane>
                    <el-tab-pane v-if="isStartedProcess" label="流程跟踪" name="second">
                        <template v-if="activeName == 'second'">
                            <el-card shadow="never" style="margin-top: 5px;">
                                <wf-design ref="bpmn" style="height: 500px;" :options="bpmnOption"></wf-design>
                            </el-card>
                        </template>
                    </el-tab-pane>                    
                </el-tabs>
            </div>
        </div>

        <BottomLine
            ref="bottomLine"
            v-if="processDetail.flow"
            :batchStatus='false'
            :auditState="basicInfoData.auditStatus"
            :processDetail="processDetail"
            :isStartedProcess="isStartedProcess"
            :goEdit="false"
            @buildNewOne="buildNewOne"
            @startProcess="saveProject(true)"
            @saveTask="saveTask"
            @saveProject="saveProject"
            @flowNext="flowNext"
            @openPrintForm="goPrint"
            @refreshData="refreshData"
        />
    </basic-container>
</template>
<script>
import * as api from "@/api/zd/project";

import InfoContainer from "@/components/infoContainer/infoContainer";
import Accessory from "@/components/accessoriesother/accessory"
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentStep from "@/components/workflowComponents/commentStep/commentStep"
import CommentTable from "@/components/workflowComponents/commentTable/commentTable"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine"
import workFlow from "@/mixins/workFlow";
import { mapGetters } from "vuex";
export default {
    name: 'ReLandingFlowBatch',
    mixins: [workFlow],
    data() {
        return {
            flowableId: '',
            tableData: [],
            basicInfoData: {},
            activeName: 'first',
            InfoContainerConfig: {
                infoTitle: '业务明细',
                infoContent: [{
                    title: '',
                    prop: 'basicInfo'
                }]
            },
            auditStatus: '',
            isStartedProcess: true,
            option: {
                align: "center",
                card: true,
                addBtn:false,
                editBtn:false,
                addRowBtn:false,
                cellBtn:false,
                cancelBtn:false,
                delBtn: false,
                labelWidth: 100,
                index:true,
                indexLabel:'序号',
                menu: true,
                menuWidth: 100,
                column: [
                    {
                        label: "客户名称",
                        prop: "custId",
                        type: "select",
                        filterable:'true' ,
                        dicUrl: "/api/blade-/zd/custom/getListDefault",
                        dicMethod: "post",
                        dicQuery: {},
                        props: {
                        label: "custName",
                        value: "id",
                        },
                        dataType: "string",
                        display: true,
                        width:200,
                    },{
                        label: "申请银行",
                        prop: "bankName",
                        width:200,
                        overHidden: true
                    },{
                        label: "申请转贷金额",
                        prop: "quota",
                        width:120,
                        formatter: (row, value, label, column) => {
                            return this.getMoney(value)
                        }
                    },{
                        label: "转贷资金出款时间",
                        prop: "expectPayDate",
                        width: 150
                    },{
                        label: "预计使用天数",
                        width: 120,
                        prop: "expectUseDay",
                    },{
                        label: "使用费率",
                        width: 120,
                        prop: "loanRate",
                        formatter: (row, value, label, column) => {
                            if (value == -1) {
                                return "-";
                            } else {
                                return `${Number(value)*100}%/天`
                            }
                        }
                    },{
                        label: "备注",
                        width: 150,
                        prop: "remark"
                    }
                ]
            },
            page: {
                currentPage: 1,
                total: 0,
                layout: "total,pager,prev, next",
                background: false,
                pageSize: 10,
            },            
        }
    },
    components: {
        Accessory,
        AuditInfo,
        CommentStep,
        CommentTable,
        BottomLine,
        CommonSelect,
        CommentBlock,
        InfoContainer        
    },
    created() {
        // this.getList()
        this.flowableId = this.$route.params.id
        // 查询流程配置
        this.getBasicConfigData()
    },
    methods: {
        handleDetail(row) {
            this.$router.push({ path: `/zd/project/detail/${row.id}` });
        },
        async getList() {
            // 当前流程的flow
            let params = {
                flowableId: this.$route.params.id
            }
            let res = await api.getLists(params)
            this.tableData = res.data.data.list
            this.auditStatus = this.tableData[0].auditStatus
        },

        async getBasicConfigData() {
            this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
            // 获取当前流程文件上传列表权限 permissionList
            this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
            // 设置流程表单路径
            this.queryProcessFormDetail(this.processDefinedId)

            this.queryFlowData(this.flowableId)  
        },
   

        refreshData() {
            this.getList()
            this.getBasicConfigData()
        },

        fileChange(fileList) {
            let self = this
            if(fileList.length > 0) {
                this.attchmentList = []
                fileList.map(item => {
                    self.attchmentList.push({
                        name: item.name,
                        url: item.response.data.link
                    })
                })
            }
        },

        // 保存尽调数据
        async saveTask() {
            await this.workFlowSaveTask()
            // 刷新数据
            this.saveTask = {
                comment: '',
                attachment: []
            }            
            this.queryCompleteDetail(this.id)
            this.$forceUpdate()
        },

        // 流程流转
        async flowNext() {
            let processInsId = this.processDetail.process.processInstanceId
            let taskId = this.processDetail.process.taskId
            let valid = false
            // 流程表单数据
            if(this.$refs.auditInfo.avueFormConfig.column && this.$refs.auditInfo.avueFormConfig.column.length > 0){
                valid = this.$refs.auditInfo.validData()
            }else {
                valid = true
            }
            if(valid){
                let customData = this.$refs.auditInfo.commentDetail
                let formData = this.$refs.auditInfo.$data.formData

                let variables = this.dealAuditForm(formData, customData)

                let res = await this.taskFlowNext(
                    taskId,
                    processInsId,
                    this.workFlowData.attchmentList?this.workFlowData.attchmentList:[],
                    this.workFlowData.opinionContent?this.workFlowData.opinionContent:'',
                    variables
                )
                // 刷新数据
                this.refreshData()
                this.$forceUpdate()
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.relendging-flow-container{
    background-color: #fff;
    overflow: hidden auto;
    padding: 15px !important;
    padding-bottom: 30px !important;
    /deep/ .info-container-temp .box-card .detail-one {
        padding: 10px 15px !important;
    }
    /deep/ .avue-crud__menu {
        min-height: 0 !important;    
        display: none;
    }
    /deep/ .avue-crud__pagination{
        padding: 0 !important;
        display: none !important;
    }
    .tabel-remark{
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        line-height: 24px;
        margin: 0 0.5%;
        margin-top: 10px;
        .remark-title{
            font-weight: 700;
            font-style: normal;
            color: #999999;
            font-size: 13px;
            line-height: 24px;
            padding-left: 12px;
            padding-right: 11px;            
        }
    }
    .inner-con{
        min-width: 1000px;
        max-width: 1100px;
        margin: 0 auto;
        margin-top: 3px;
        .project-title{
            color: #333;
            font-size: 18px;
            font-weight: bold;
        }
        .project-status{
            .status-title{
                text-align: right;
                font-family: '微软雅黑', sans-serif;
                font-weight: 400;
                color: #999999;
                font-size: 14px;
            }
            .status-content{
                text-align: right;
                font-family: '微软雅黑', sans-serif;
                font-weight: 400;
                color: #666666;
                font-size: 20px;
            }
        }    
    }
    .stateTopdiv::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 5px;
    }
    .color_0::before {
        background: #fec03d;
    }
    .color_1::before {
        background: #409eff;
    }
    .color_2::before {
        background: #51d351;
    }
    .color_3::before {
        background: #F56C6C;
    }
    .color_4::before {
        background: #F56C6C;
    }
}
/deep/.el-tabs__item {
  font-size: 18px ;
  font-weight: bolder ;
  margin-bottom: 10px ;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}
</style>